<template>
  <v-row class="py-3">
    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("transmissions.id") }}:</b> {{ transmission.id }}
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b> {{ $t("transmissions.source") }}: </b>
        <router-link
          class="link black--text"
          :to="{
            name: 'source',
            params: {
              project_id: $route.params.project_id,
              id: transmission.source_id
            }
          }"
          >{{ transmission.source_name }}</router-link
        >
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("transmissions.status") }}:</b> {{ transmission.status }}
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b> {{ $t("transmissions.receive-time") }} : </b>
        {{
          transmission.receive_time &&
            $dateTime(
              new Date(transmission.receive_time),
              "long",
              "",
              project.timezone
            )
        }}
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("transmissions.sender") }}:</b> {{ transmission.sender }}
      </p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "GeneralInformationTransmission",
  components: {},
  computed: {
    transmission: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/transmissionStore/getItem"
        ];
      }
    },
    project() {
      return this.$store.getters["projectStore/getItem"];
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.link {
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
</style>
